import Http from '../request-method.js';
import Crypto from '../../utils/utils-crypto.js';

export default {
    //获取赛事明细
    getMatchDetail(data) {
        return Http.get('/MatchApi/GetMatchDetail', data);
    },
    //获取赛事列表
    selectMatchList(data) {
        return Http.post('/MatchApi/SelectMatchList', data);
    },
    //根据赛事名查询赛事列表，下拉框条件筛选使用
    selectMatchListByName(data) {
        return Http.get('/MatchApi/SelectMatchListByName', data);
    },
    //删除赛事
    delMatch(data) {
        return Http.get('/MatchApi/DelMatch', data);
    },
    //编辑赛事信息
    editMatch(data) {
        return Http.post('/MatchApi/EditMatch', data);
    },
    //查询项目类型列表
    selectProjectTypeList() {
        return Http.get('/MatchApi/SelectProjectTypeList', {});
    },
    //编辑项目
    editMatchProject(data) {
        return Http.post('/MatchApi/EditMatchProject', data);
    },
    //查询裁判列表
    selectRefereeList(data) {
        return Http.post('/MatchApi/SelectRefereeList', data);
    },
    //编辑裁判信息
    editReferee(data) {
        return Http.post('/MatchApi/EditReferee', data);
    },
    //删除裁判
    delReferee(data) {
        return Http.get('/MatchApi/DeleteReferee', data);
    },
    //锁定/解锁裁判信息
    lockOrUnLockReferee(data) {
        return Http.get('/MatchApi/LockOrUnLockReferee', data);
    },
    //编辑赛事分组
    editMatchGroup(data) {
        return Http.post('/MatchApi/EditMatchGroups', data);
    },
    //查询项目裁判人数设置
    selectProjectRefereePeopleConfig() {
        return Http.get('/MatchApi/SelectProjectRefereePeopleConfig', {});
    },
    //删除项目
    deleteMatchProject(data) {
        return Http.get('/MatchApi/DeleteMatchProject', data);
    },
    //查询报名运动员列表
    selectMatchContestantUser(data) {
        return Http.post('/MatchApi/SelectMatchContestantUser', data);
    },
    //删除报名运动员
    deleteMatchContestantUser(data) {
        return Http.get('/MatchApi/deleteMatchContestantUser', data);
    },
    //编辑报名运动员
    editMatchContestantUser(data) {
        return Http.post('/MatchApi/EditMatchContestantUser', data);
    },
    //查询赛事场次配置
    selectMatchVenueConfig(data) {
        return Http.get('/MatchApi/SelectMatchVenueConfig', data);
    },
    //编辑赛事场次配置
    editMatchVenueConfigs(data) {
        return Http.post('/MatchApi/EditMatchVenueConfigs', data);
    },
    //删除赛事场次配置
    deleteMatchVenueConfig(data) {
        return Http.get('/MatchApi/DeleteMatchVenueConfig', data);
    },
    //获取赛事运动员编排信息
    getMatchContestantUserArrange(data) {
        return Http.get('/MatchApi/GetMatchContestantUserArrange', data);
    },
    //项目编排
    projectArrange(data) {
        return Http.post('/MatchApi/ProjectArrange', data);
    },

    projectArrangeV2(data) {
        return Http.post('/MatchApi/ProjectArrangeV2', data);
    },

    chechProjectArrangeStatus(data) {
        return Http.get('/MatchApi/ChechProjectArrangeStatus', data);
    },
    
    //运动员编排兑换位置
    contestantUserExchange(data) {
        return Http.get('/MatchApi/ContestantUserExchange', data);
    },
    //查询场次项目配置
    selectVenueProjectConfig(data) {
        return Http.get('/MatchApi/SelectVenueProjectConfig', data);
    },
    //提交处理场次项目配置
    handlerMatchVenueProject(data) {
        return Http.post('/MatchApi/HandlerMatchVenueProject', data);
    },
    //设置赛事状态
    setMatchStatus(data) {
        return Http.get('/MatchApi/SetMatchStatus', data);
    },
    //获取赛事全部日程
    getMatchWholeSchedule(data) {
        return Http.get('/MatchApi/GetMatchWholeSchedule', data);
    },
    getMatchWholeScheduleV2(data){
        return Http.get('/MatchApi/GetMatchWholeScheduleV2', data);
    },
    //查询裁判类型列表
    selectRefereeTypeList(data) {
        return Http.get('/MatchApi/SelectRefereeTypeList', data);
    },
    //查询赛事裁判人数配置列表
    selectMatchRefereeConfigList(data) {
        return Http.get('/MatchApi/SelectMatchRefereeConfigList', data);
    },
    //编辑赛事裁判人数配置
    editMatchRefereeConfig(data) {
        return Http.post('/MatchApi/EditMatchRefereeConfig', data);
    },
    //推送运动员上场日程信息
    pushMatchContestantUserSchedule(data){
        return Http.get('/MatchApi/PushMatchContestantUserSchedule', data);
    },
    //取消运动员上场日程信息
    cancelMatchContestantUserSchedule(data){
        return Http.get('/MatchApi/CancelMatchContestantUserSchedule', data);
    },
    cancelMatchContestantUserSchedule1(data){
        return Http.get('/MatchApi/CancelMatchContestantUserSchedule1', data);
    },
    //查询赛事运动员上场日程信息列表
    getMatchContestantUserSchedule(data){
        return Http.get('/MatchApi/GetMatchContestantUserSchedule',data);
    },
    getOnLineReferee(data){
        return Http.get('/MatchApi/GetOnLineReferee',data);
    },
    setContestantUserScore(data){
        return Http.post('/MatchApi/SetContestantUserScore', data);
    },
    batchEditMatchProject(data){
        return Http.post('/MatchApi/BatchEditMatchProject', data);
    },
    setUserStatus(data){
        return Http.post('/MatchApi/SetUserStatus', data);
    },
    setMatchContestantUserComplete(data){
        return Http.get('/MatchApi/SetMatchContestantUserComplete', data);
    },
    exportProjectScore(data){
        return Http.post('/MatchApi/ExportProjectScore', data);
    },
    exportAllProjectScore(data){
        return Http.get('/MatchApi/ExportAllProjectScore', data);
    },
    selectMatchRegions(data){
        return Http.get('/MatchApi/SelectMatchRegions', data);
    },
    editMatchRegions(data){
        return Http.post('/MatchApi/EditMatchRegionInfo', data);
    },
    delMatchRegionInfo(data){
        return Http.get('/MatchApi/delMatchRegionInfo', data);
    },
    exportMatchSchedule(data){
        return Http.get('/MatchApi/ExportMatchSchedule', data);
    },
    getMatchContestantUserScore(data){
        return Http.get('/MatchApi/GetMatchContestantUserScore', data);
    },
    editMatchContestantUserScore(data){
        return Http.post('/MatchApi/EditMatchContestantUserScore', data);
    },
    clacPatternMatchScore(data){
        return Http.post('/MatchApi/ClacPatternMatchScore', data);
    },
    getLatestScorePros(data){
        return Http.get('/MatchApi/GetLatestScorePros', data);
    },
    selectMatchTeamConfigs(data){
        return Http.get('/MatchApi/SelectMatchTeamConfigs', data);
    },
    editMatchTeamConfig(data){
        return Http.post('/MatchApi/EditMatchTeamConfig', data);
    },
    deleteMatchTeamConfig(data){
        return Http.get('/MatchApi/DeleteMatchTeamConfig', data);
    },
    selectMatchTeamItems(data){
        return Http.get('/MatchApi/SelectMatchTeamItems', data);
    },editMatchTeamItem(data){
        return Http.post('/MatchApi/EditMatchTeamItem', data);
    },
    exportTeamScore(data){
        return Http.get('/MatchApi/ExportTeamScore', data);
    },
    setProReferenceTime(data){
        return Http.get('/MatchApi/SetProReferenceTime', data);
    },
    setProReferenceTime2(data){
        return Http.get('/MatchApi/SetProReferenceTime2', data);
    },
    editUserScoreDetail(data){
        return Http.post('/MatchApi/EditUserScoreDetail', data);
    },
    calcScore(data){
        return Http.post('/MatchApi/CalcScore', data);
    },
    editRefereeTypeInfo(data){
        return Http.post('/MatchApi/EditRefereeTypeInfo', data);
    },
    setProjectDisclosureStatus(data){
        return Http.get('/MatchApi/SetProjectDisclosureStatus', data);
    },
    getCurrMatchRegionUserScore(data){
        return Http.get('/MatchApi/GetCurrMatchRegionUserScore', data);
    },
    selectSignUpForms(data) {
        return Http.post('/MatchApi/SelectSignUpForms', data);
    },
    auditSignUpForm(data){
        return Http.get('/MatchApi/AuditSignUpForm', data);
    },
    exportMatchProjectSignUpNumber(data){
        return Http.get('/MatchApi/ExportMatchProjectSignUpNumber', data);
    },
    exportMatchWholeSchedule(data){
        return Http.get('/MatchApi/ExportMatchWholeSchedule', data);
    },
    exportMatchUnitAttendanceNumber(data) {
        return Http.get('/MatchApi/ExportMatchUnitAttendanceNumber', data);
    },
    exportMatchUnitTeamRoster(data) {
        return Http.get('/MatchApi/ExportMatchUnitTeamRoster', data);
    },
    matchArrangeOverview(data){
        return Http.post('/MatchApi/MatchArrangeOverview', data);
    },
    submitArrangeRule(data){
        return Http.post('/MatchApi/SubmitArrangeRule', data);
    },
    getMatchScheduleUser(data){
        return Http.get('/MatchApi/GetMatchScheduleUser', data);
    },
    getMatchScheduleUserV2(data) {
        return Http.get('/MatchApi/GetMatchScheduleUserV2', data);
    },
     getMatchScheduleUserV3(data) {
         return Http.post('/MatchApi/GetSimpleMatchScheduleUser', data);
    },
    getMatchScheduleUserV4(data) {
         return Http.post('/MatchApi/GetSimpleMatchScheduleUserV3', data);
    },

    getMatchCompetitionPersonnel(data){
        return Http.get('/MatchApi/GetMatchCompetitionPersonnel', data);
    },
    generateCompetitionPass(data){
        return Http.post('/MatchApi/GenerateCompetitionPass', data);
    },
    batchGenerateCompetitionPass(data){
        return Http.post('/MatchApi/BatchGenerateCompetitionPass', data);
    },
    selectUnitAthleteByUnitId(data){
        return Http.get('/MatchApi/SelectUnitAthleteByUnitId', data);
    },
    selectUnitAthleteByUnitSignFormId(data){
        return Http.get('/MatchApi/SelectUnitAthleteByUnitSignFormId', data);
    },
    submitReplaceAthlete(data){
        return Http.post('/MatchApi/SubmitReplaceAthlete', data);
    },
    selectAllUnitName(){
        return Http.get('/MatchApi/SelectAllUnitName');
    },
    selectUnitScoreDetails(data){
        return Http.get('/MatchApi/SelectUnitScoreDetails', data);
    },
    exportUnitScoreDetails(data){
        return Http.get('/MatchApi/ExportUnitScoreDetails', data);
    },
    getMatchProjectTimeConfig(data){
        return Http.get('/MatchApi/GetMatchProjectTimeConfig', data);
    },
    getMatchProjectTimeTakenConfig(data){
        return Http.get('/MatchApi/GetMatchProjectTimeTakenConfig', data);
    },
    setMatchProjectReferenceTime(data){
        return Http.post('/MatchApi/SetMatchProjectReferenceTime', data);
    },
    setMatchProjectReferenceTime2(data){
        return Http.post('/MatchApi/SetMatchProjectReferenceTime2', data);
    },
    clearMatchProjectReferenceTime(data){
        return Http.get('/MatchApi/ClearMatchProjectReferenceTime', data);
    },
    exportMatchProjectTime(data){
        return Http.get('/MatchApi/ExportMatchProjectTime', data);
    },
    exportMatchProjectTime2(data){
        return Http.get('/MatchApi/ExportMatchProjectTime2', data);
    },
    selectUnitAllTeamLeaders(data){
        return Http.get('/MatchApi/SelectUnitAllTeamLeaders', data);
    },
    submitSignUpFormTeamLeaders(data){
        return Http.post('/MatchApi/SubmitSignUpFormTeamLeaders', data);
    },
    selectMatchRelatUnitNameList(data){
        return Http.get('/MatchApi/SelectMatchRelatUnitNameList', data);
    },
    checkSignUpFormStatus(data){
        return Http.get('/MatchApi/CheckSignUpFormStatus', data);
    },
    getMatchSchedule(data){
        return Http.get('/MatchApi/GetMatchSchedule', data);
    }

}